<script>
    import {fade} from 'svelte/transition'

    import SiloSummary from "./silo_summary.svelte"
    import SiloLevel from "./silo_level.svelte"
    import SiloLevelHistory from "./silo_level_history.svelte"
    import {get_sensor_id} from '../gqlQueries'
    import {DEFAULT_SENSOR_INFOS, getSensorInformation} from "../firestore"

    import {of} from 'rxjs'
    import {catchError, mergeMap, tap} from "rxjs/operators"

    export let params = {};
    let id = params.id;

    let equipment = undefined;
    let tempEquipment = undefined;

    get_sensor_id({id: id, sort: true, messages: true}).pipe(
        tap(data => tempEquipment = data),
        mergeMap(data => getSensorInformation({id: data.id, client: ""}).pipe(
            catchError(() => of(DEFAULT_SENSOR_INFOS))
        ))
    ).subscribe(data => {
        tempEquipment.infos = data;
        equipment = tempEquipment;
    });
</script>

<svelte:head><title>Axces2 - Sensor details</title></svelte:head>

{#if equipment !== undefined}
    <div class="container-fluid">

        <div class="row page-titles">
            <div class="col-md-5 col-8 align-self-center">
                <h3 class="text-themecolor">{equipment.infos.name}</h3>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Sites Overview</li>
                    <li class="breadcrumb-item"><a href="#/equipment">Equipment Summary</a></li>
                    <li class="breadcrumb-item active">{equipment.infos.name}</li>
                </ol>
            </div>
        </div>

        <section transition:fade="{{duration: 200}}">
            <div class="card-group separate">
                <SiloSummary silo={equipment}/>
                <SiloLevel silo={equipment}/>
            </div>

            <SiloLevelHistory silo={equipment}/>

        </section>
    </div>
{:else}
    <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
    </svg>
{/if}